import { Alert, Button, Input, Typography } from 'antd'
import TabPane from './TabPane'
import {
    ShareAltOutlined
} from '@ant-design/icons';
import { useContext, useLayoutEffect, useRef, useState } from 'react';
import { MapContext } from '../../App/MapContextContainer';
import { PREFERRED_WKID } from '../../pages/CustomAreas/UserDataContextContainer';
import Extent from '@arcgis/core/geometry/Extent';
import * as projection from "@arcgis/core/geometry/projection";
import type { InputRef } from 'antd'
import { useTranslation } from 'react-i18next';

interface IProps {
    number: number,
    showFindForestMask?: boolean;
}

export const ShareTabIcon = ShareAltOutlined;

export default function ShareTab(props: IProps) {
    const [message, setMessage] = useState("");
    const [link, setLink] = useState("");
    const mapContext = useContext(MapContext);
    const linkInputRef = useRef<InputRef>(null);
    const visibilityDivRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation("sidePanelTabs");

    useLayoutEffect(() => {
        if (linkInputRef.current && link) {
            var copyText = linkInputRef.current;

            if (copyText) {
                copyText.select();
                copyText.setSelectionRange(0, 99999); // For mobile devices
            }

            var divElem = visibilityDivRef.current;

            if (divElem) {
                divElem.scrollIntoView();
            }
        }
    }, [link]);

    const onCreateLinkButtonClick = async () => {
        const view = mapContext.getView();

        if (view) {
            let geometryInPreferredWkid = projection.project(view.extent, { wkid: PREFERRED_WKID }) as Extent;

            const center = geometryInPreferredWkid.center;
            const zoom = view.zoom;

            if (center && zoom) {
                const link = `${window.location.origin}${window.location.pathname}?point=${center.y},${center.x}&zoom=${zoom}`;
                setLink(link);

                try {
                    await navigator.clipboard.writeText(link);

                    setMessage(t("linkinKopiointiOnnistui"));
                } catch (error) {
                    setMessage(t("linkinKopiointiEiOnnistunut"));
                }
            }
        }
    };

    return (
        <TabPane number={props.number}>
            <>
                <Typography.Title level={4}>{t("jakamisenOtsikko")}</Typography.Title>
                <p>
                    {t("jakamisenTeksti")}
                </p>
                <p>
                    <Button type='primary' onClick={onCreateLinkButtonClick}>{t("jakamisenNappula")}</Button>
                </p>
                <Input ref={linkInputRef} type='text' readOnly={true} value={link} />
                <div ref={visibilityDivRef} style={{ "height": "5em" }}>
                    {message && <Alert type="success" message={message} />}
                </div>
            </>
        </TabPane>
    )
}